import { render, staticRenderFns } from "./fundingHome.vue?vue&type=template&id=5af036a7&scoped=true&"
import script from "./fundingHome.vue?vue&type=script&lang=js&"
export * from "./fundingHome.vue?vue&type=script&lang=js&"
import style0 from "./fundingHome.vue?vue&type=style&index=0&id=5af036a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af036a7",
  null
  
)

export default component.exports